export class DiscountObj{
	discountPrice  : any = null ;
	originalPrice  : any = null ;
	remainingAmount: any = null ;
	totalCost      : any = null ;
}
	
export class ApplicableTax{
	tax            : any = null ;
	taxType        : any = null ;
	taxRate        : any = null ;
	country        : any = null ;
}

import { Component, OnInit , Input , Output , HostListener , ViewChild , ElementRef , EventEmitter , ChangeDetectorRef} from '@angular/core';
import { PaymentService } from "../../services/payment.service";
import { DataService    } from "../../services/data.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { KycModalComponent } from "../../shared/kyc-modal/kyc-modal.component";

import { FormGroup, FormBuilder, Validators , NgForm } from "@angular/forms";
// import { StripeService, StripeCardComponent, Elements, Element as StripeElement , ElementOptions, ElementsOptions } from "ngx-stripe";
import { StripeService  } from "ngx-stripe";

import { StripeKey } from "../../utils/misc" ;

declare var StripeCheckout:any;
declare var Razorpay: any;

declare var elements : any ;
declare var stripe   : any ;
declare var Razorpay: any;
declare const Stripe;
@Component({
  selector: 'app-checkout-new',
  templateUrl: './checkout-new.component.html',
  styleUrls: ['./checkout-new.component.scss']
})
export class CheckoutNewComponent implements OnInit{

	@Input() planData     : any ;
	@Input() planStatus   : any ; 
	@Input() priceCurrency: any ; 
	@Output() paymentComplete = new EventEmitter();

	handler               : any;
	amount                : any = 5000;
	stripeKey             : any = StripeKey ;
	// stripeKey             : any = "pk_test_MzcP5HYKsN62OMepT4ztcw5A00f7fjm8uo" ; // DEV
	// stripeKey             : any = "pk_live_JqFknkpP6c2IKPqdLtVhzFtn00WRITdyg1" ; // PROD
	
	showCheckoutWizard    : boolean = true ;
	isTrxnSuccessful      : boolean = false ;
	
	email                 : any ;
	paymentId: string;
    error: string;
	discountObj           : DiscountObj =  new DiscountObj();
	
	couponCode            : any  = null;
	couponId              : any  = null;
	
	couponRedeemSuccess   : boolean = false;
	
	bsModalRef            : BsModalRef;
	
	existingBalance       : any = null ;
	applicableTax         : ApplicableTax = new ApplicableTax() ;
	emailPattern          : any = "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{0}$";

	selected 			  : any = null;

	clientData 			  : any = null;
	trialPlan  			  : boolean = false;
	// NOTE:
	// Stripe amounts are based equal to 1/100th of the base currency, so an amount of 500 equals $5.00.
	//Custom Design
	// @ViewChild('cardInfo') cardInfo: ElementRef;
	// card                           : any;
	// cardHandler                    = this.onChange.bind(this);
	// error                          : string;
	
	isIndia;
	options = {
		"key": "rzp_test_8PjqnJb31uns6z",
		"amount": "", 
		"name": "KycHub",
		"description": "Know Your Customer - KYC and AML for different Industries using Machine Learning",
		"image":"https://www.kychub.com/favicon.ico",
		"order_id":"",
		"handler": function (response){
			var event = new CustomEvent("payment.success", 
				{
					detail: response,
					bubbles: true,
					cancelable: true
				}
			);    
			window.dispatchEvent(event);
		}
	}
	constructor(
	private _payment     : PaymentService,
	private _data        : DataService,
	private fb           : FormBuilder,
	private cd           : ChangeDetectorRef,
    private modalService : BsModalService,
	// private stripeService: StripeService
	){ }

	ngOnInit(){
		console.log('coming to checkout new',this.planData);
		console.log(this.planStatus);
        this.isIndia =window.sessionStorage.getItem('isIndia');
		if(!this.planData.isInvoice) this.configureStripe();
		this._data.loadClientData.subscribe( data =>{
			this.clientData = data;
		})
		// // if(this.planStatus && this.planStatus == "UPGRADE"){
		// // 	this.redeemDefaultCouponCode(this.planData);
		// // }
		// // else{
		// // 	if(this.planData){
		// // 		let applicableCost = this.planData["subscriptionDuration"] == "ANNUAL" ? this.planData["planCostAnnualy"] : this.planData["planCostMonthly"] ;
		// // 		this.amount = applicableCost ? applicableCost : this.planData["maxCost"] ;
		// // 		this.amount = this.amount * 100 ;
		// // 		this.discountObj.originalPrice = this.amount ;
		// // 	}
		// // 	this.configureStripe();
		// // 	// this.applyTax();
		// // }
		// if(this.planData && this.planData["maxCost"]){
		// 	console.log("PAY AS GO");
		// 	this.amount =  this.planData["maxCost"] ;
		// 	this.amount = this.amount * 100 ;
		// 	this.discountObj.originalPrice = this.amount ;
		// 	this.configureStripe();
		// }
		// else{
		// 	console.log("Subscription Plan");
		// 	this.redeemDefaultCouponCode(this.planData);
		// }
	}
	getSelected(i){
		console.log(i);
		this.selected = i;
	}
	redeemDefaultCouponCode(plan){
		let redeemObj  = {
			"planId"              : plan["id"],
			"subscriptionDuration": plan["subscriptionDuration"]   //ANNUAL,MONTHLY
		};
		this._data.changeLoaderVisibility(true);
		this._payment.redeemCouponV2(redeemObj)
		.subscribe(
			(res)=>{
				this._data.changeLoaderVisibility(false);
				if(res.data && Object.keys(res.data).length){
					this.existingBalance = res.data.remainingAmount * 100 ;
					this.amount = res.data.totalCost * 100;
					this.discountObj.originalPrice = res.data.originalPrice * 100;
					this.configureStripe();
					// this.applyTax();
				}
				else{
					this._data.toastrShow("Coupon not Applicable" , "info");
				}
			}
		);
	}

	applyTax(){
		let obj = {
			"amount" : this.amount / 100 
		}
		this._payment.applyTax(obj)
		.subscribe(
			(res)=>{
				this.applicableTax.tax     = res.data.tax * 100 ;
				this.applicableTax.taxType = res.data.taxType ;
				this.applicableTax.taxRate = res.data.taxRate ;
				this.applicableTax.country = res.data.country ;

				this.amount = res.data.totalAmount * 100;
				this.configureStripe();
			}
		);
	}

	resetCoupon(){
		this._data.changeLoaderVisibility(true);
		this.discountObj = new DiscountObj();
		let applicableCost = this.planData["subscriptionDuration"] == "ANNUAL" ? this.planData["planCostAnnualy"] : this.planData["planCostMonthly"] ;
		this.amount = applicableCost ? applicableCost : this.planData["maxCost"] ;
		this.amount = this.amount * 100 ;
		this.discountObj.originalPrice = this.amount ;

		if(this.existingBalance){
			this.amount = this.amount - this.existingBalance ;
		}

		this.couponRedeemSuccess = false;

		// this.applyTax();
		this._data.changeLoaderVisibility(false);
	}

	configureStripe(){
		this.handler = StripeCheckout.configure({
			key: this.stripeKey,
			image: 'https://www.kychub.com/assets/img/kyc%20hub%201.png',
			locale: 'auto',
			currency : this.priceCurrency.currencyCode ,
			token: token => {
				// this._payment.processPayment(token, this.amount)
				console.log(token);
				this.processPayment(token);
			}
		});
	}

	showAllCoupons(){
		const initialState = {
            title              : `Apply Coupons`,
            type               : "show-coupons"
        };
        this.bsModalRef = this.modalService.show(KycModalComponent, {
            initialState,
            class: "modal-lg"
        });
        this.bsModalRef.content.closeBtnName = "Close";
        console.log(this.bsModalRef.content.onClose);
        this.bsModalRef.content.onClose.subscribe(result => {
            if (Object.keys(result).length) {
                this.redeemCouponCode(result);
            }
        });
	}
    RazorPayment(){
		this.paymentId = ''; 
        this.error = ''; 
		if(this.planData.planName=='Initial Setup Cost'){
			this._payment.getInitialCost().subscribe(
				data => {
					this.options.amount=data.applicationFee;
					this.options.order_id=data.razorpayOrderId;
					var rzp1 = new Razorpay(this.options);
		rzp1.open();
					   
		rzp1.on('payment.failed', function (response){    
			// Todo - store this information in the server
			console.log(response.error.code);    
			console.log(response.error.description);    
			console.log(response.error.source);    
			console.log(response.error.step);    
			console.log(response.error.reason);    
			console.log(response.error.metadata.order_id);    
			console.log(response.error.metadata.payment_id);
			this.error = response.error.reason;
		}
		);
			  })
		}
		else{
           this._payment.getStandardPaymentPlan().subscribe(
			   data=>{
				this.options.amount=data.applicationFee;
				this.options.order_id=data.razorpayOrderId;
				var rzp1 = new Razorpay(this.options);
		rzp1.open();
					   
		rzp1.on('payment.failed', function (response){    
			// Todo - store this information in the server
			console.log(response.error.code);    
			console.log(response.error.description);    
			console.log(response.error.source);    
			console.log(response.error.step);    
			console.log(response.error.reason);    
			console.log(response.error.metadata.order_id);    
			console.log(response.error.metadata.payment_id);
			this.error = response.error.reason;
		}
		);
			   }
		   )
		}
		
	}
	@HostListener('window:payment.success', ['$event']) 
    onPaymentSuccess(event): void {
        this._data.changeLoaderVisibility(true);
		if(this.planData.planName=='Initial Setup Cost'){
		this._payment.updateInitialSetup(event.detail).subscribe(
			data => {   
						this.showCheckoutWizard = false ;
						this.isTrxnSuccessful = true ;
						this._data.changeLoaderVisibility(false);
						this._data.toastrShow("Payment Successful" , "info");
						console.log(event.detail)
					})
		}
		else{
			this._payment.updateStandardPlan(event.detail).subscribe(
				data=>{
					this.showCheckoutWizard = false ;
						this.isTrxnSuccessful = true ;
						this._data.changeLoaderVisibility(false);
						this._data.toastrShow("Payment Successful" , "info");
						console.log(event.detail)	}
			)
		}
	}
	redeemCouponCode(coupon){
		this.couponCode = coupon.code ;
		this.couponId   = coupon.id ;
		let redeemObj  = {
			"subscriptionType"    : this.planData["minCost"] ? "PAYASGO" : "STANDARD_SUBSCRIPTION",
			// "saleId"           :  this.planStatus == 'UPGRADE' ? null : coupon.id ,
			"saleId"              : coupon.id ?  coupon.id : null ,
			"newPlanId"           : this.planData.id  ,
			"planStatus"          : this.planStatus ? this.planStatus : "NEW" ,
			"subscriptionDuration": this.planData["subscriptionDuration"]   //ANNUAL,MONTHLY
		};
		this._data.changeLoaderVisibility(true);
		this._payment.redeemCoupon(redeemObj)
		.subscribe(
			(res)=>{
				console.log(res);
				this._data.changeLoaderVisibility(false);
				if(res.data && Object.keys(res.data).length && res.data["discountPrice"]){
					this.discountObj = res.data ;
					for(var key in this.discountObj){
						this.discountObj[key] = this.discountObj[key] * 100 ;
					}
					this.amount = this.discountObj.totalCost ;
					this.couponRedeemSuccess = true;
					// this.applyTax();
				}
				else{
					this.couponRedeemSuccess = false ;
					this._data.toastrShow("Coupon not Applicable" , "info");
				}
			}
		);
	}
    // handlePayment2(){
	// 	let checkOut={"name": "test",
	// 	"currency":"usd",
	// 	"successUrl":"https://www.kychub.com",
	// 	"cancelUrl":"https://www.google.com",
	// 	"amount":500,
	// 	"quantity":1}
	// 	const stripe = Stripe("pk_test_51K7FT0JTN00GakIFsr8l4vndW8dgK1O30baKedMGGFVB4fwsJgYVpoB3wd7x2ppTJwthLTYqoy1BKtcHr82H4JBs006zDemTNR");
	// 	this._payment.stripePayment(checkOut).subscribe(res=>{
	// 		stripe.redirectToCheckout({
	// 			sessionId: res.id
	// 		  });
	// 	})
	// }
	handlePayment(){
		var amount = (this.planData.totalPayableamount) ? this.planData.totalPayableamount : this.planData.price;
			amount = (amount * this.priceCurrency.conversionRate ) * 100;
			
		this.handler.open({
			name       : 'KycHub',
			description: 'Know Your Customer - KYC and AML for different industries using machine learning',
			image      : "https://www.kychub.com/favicon.ico" ,
			excerpt    : 'Deposit Funds to Account',
			amount     : amount.toFixed(2),
			email 	   : this.clientData.email
		});
	}
    
	handleInvoicePayment(){
		var amount = (this.planData.totalPayableamount) ? this.planData.totalPayableamount : this.planData.price;
		amount = (amount * this.priceCurrency.conversionRate ) * 100;
		StripeCheckout.configure({
			key: this.stripeKey,
			image: 'https://www.kychub.com/favicon.ico',
			locale: 'elementsOptions',
			currency : this.planData.currencyCode ,
			token: token => {
				// this._payment.processPayment(token, this.amount)
				console.log(token);
		 	this.processInvoicePayment(token,amount);
			}
		}).open({
			name       : 'KycHub',
			description: 'Know Your Customer - KYC and AML for different industries using machine learning',
			image      : "https://www.kychub.com/favicon.ico" ,
			excerpt    : 'Deposit Funds to Account',
			amount     : amount,
			email 	   : this.clientData.email
		});
	}
	processInvoicePayment(tokenObj,amount){
		let paymentObj = 
			{
				"description":this.planData.planName,
			    "stripeEmail" 	: tokenObj.email,
				"stripeToken" 	: tokenObj.id,
				"amount":amount,
				"currency":this.priceCurrency.currencyCode,
			};
			if(this.planData.planName=='Initial Setup Cost'){
				this._data.changeLoaderVisibility(true);
				this._payment.updateOneTimeStripe(paymentObj)
				.subscribe(
					(res)=>{
						this.showCheckoutWizard = false ;
						this.isTrxnSuccessful = true ;
						this._data.changeLoaderVisibility(false);
						this._data.toastrShow("Payment Successful" , "info");
					}
				);
			}
			else{
				this._data.changeLoaderVisibility(true);
				console.log(paymentObj)
				this._payment.updateMonthlyStripe(paymentObj)
				.subscribe(
					(res)=>{
						this.showCheckoutWizard = false ;
						this.isTrxnSuccessful = true ;
						this._data.changeLoaderVisibility(false);
						this._data.toastrShow("Payment Successful" , "info");
					}
				);
			}
		
	}
	@HostListener('window:popstate')
	onPopstate() {
		this.handler.close()
	}

	processPayment(tokenObj){
		var amount = (this.planData.totalPayableamount) ? this.planData.totalPayableamount : this.planData.price;
		tokenObj.price = (amount * this.priceCurrency.conversionRate );
		tokenObj.price = tokenObj.price.toFixed(2)
		// planStatus ==> NEW, UPDATE, UPGRADE
		// this._data.changeLoaderVisibility(true);
		// let newPlan = {
		// 		"planId"              : this.planData.id ,
		// 		"saleId"              : this.couponRedeemSuccess ? this.couponId : null ,
		// 		// "saleId"           : this.couponId ? this.couponId : null ,
		// 		"subscriptionType"    : this.planData["minCost"] ? "PAYASGO" : "STANDARD_SUBSCRIPTION",
		// 		"planStatus"          : this.planStatus ? this.planStatus : "NEW" ,
		// 		"currencyCode"        : this.priceCurrency,
		// 		// "currency"            :"GBP",
		// 		"amount"              : this.amount/100 ,
		// 		"stripeEmail"         : tokenObj.email ,
		// 		"stripeToken"         : tokenObj.id ,
		// 		"subscriptionDuration": this.planData["subscriptionDuration"]   //ANNUAL,MONTHLY
		// }
		// this._payment.processPayment(newPlan)
		// .subscribe(
		// 	(res)=>{
		// 		console.log(res);
		// 		this.showCheckoutWizard = false ;
		// 		this.isTrxnSuccessful = true ;
		// 		this._data.changeLoaderVisibility(false);
		// 		this._data.toastrShow("Payment Successful" , "info");
		// 	}
		// );
		
		if(this.selected){
			console.log("yo I got a selected one   ",this.selected);
			if(this.selected.includes('monthly')){
				var index = parseInt(this.selected.replace(/.*[a-z-]/,''));
				this.processTrialSubscriptionPayment(tokenObj,this.planData.monthlyLicence[index])
			}else{
				var index = parseInt(this.selected.replace(/.*[a-z-]/,''));
				this.processTrialSubscriptionPayment(tokenObj,this.planData.annualLicence[index])
			}
		}else if(this.planData.type == "STANDARD_SUBSCRIPTION"){
			this.processSubscriptionPayment(tokenObj);
		}else if(this.planData.type == "PAYASGO"){
			this.processPayAsGoPayment(tokenObj);
		}else if(this.planData.licenceType){
			this.processSubscriptionPayment(tokenObj);
		}else{
			console.log("OOPS NOT YET IMPLEMENTED",this.planData);
		}
	}

	// processPayAsGoPayment(tokenObj){
	// 	let paymentObj = {
	// 		"planId"      : this.planData.id ,
	// 		"amount"      : this.amount/100 ,
	// 		"currencyCode": this.priceCurrency ,
	// 		"stripeEmail" : tokenObj.email,
	// 		"stripeToken" : tokenObj.id
	// 	}
	// 	this._data.changeLoaderVisibility(true);
	// 	this._payment.processPayAsGoPayment(paymentObj)
	// 	.subscribe(
	// 		(res)=>{
	// 			this.showCheckoutWizard = false ;
	// 			this.isTrxnSuccessful = true ;
	// 			this._data.changeLoaderVisibility(false);
	// 			this._data.toastrShow("Payment Successful" , "info");
	// 		}
	// 	);
	// }

	processPayAsGoPayment(tokenObj){
		var amount = (this.planData.totalPayableamount * this.priceCurrency.conversionRate) + 0;
		let paymentObj = 
			{
				"payAsYouGoId" 	: this.planData.id,
				"price" 		: (this.planData.totalPayableamount * this.priceCurrency.conversionRate).toFixed(2),
				"currencyCode" 	: this.priceCurrency.currencyCode,
				"stripeEmail" 	: tokenObj.email,
				"stripeToken" 	: tokenObj.id
			};
		this._data.changeLoaderVisibility(true);
		if(this.planData.isNewLicence){
			this._payment.processPayAsGoPaymentV2Update(paymentObj)
			.subscribe(
				(res)=>{
					this.showCheckoutWizard = false ;
					this.isTrxnSuccessful = true ;
					this._data.changeLoaderVisibility(false);
					this._data.toastrShow("Payment Successful" , "info");
				}
			);
		}else{
			this._payment.processPayAsGoPaymentV2Add(paymentObj)
			.subscribe(
				(res)=>{
					this.showCheckoutWizard = false ;
					this.isTrxnSuccessful = true ;
					this._data.changeLoaderVisibility(false);
					this._data.toastrShow("Payment Successful" , "info");
				}
			);
		}
	}

	// processSubscriptionPayment(tokenObj){
	// 	let paymentObj = {
	// 		"planId"              : this.planData.id ,
	// 		"stripeEmail"         : tokenObj.email,
	// 		"stripeToken"         : tokenObj.id,
	// 		"currencyCode"        : this.priceCurrency,
	// 		"subscriptionDuration": this.planData["subscriptionDuration"]   //ANNUAL,MONTHLY
	// 	}
	// 	this._data.changeLoaderVisibility(true);
	// 	this._payment.processSubscriptionPayment(paymentObj)
	// 	.subscribe(
	// 		(res)=>{
	// 			this.showCheckoutWizard = false ;
	// 			this.isTrxnSuccessful = true ;
	// 			this._data.changeLoaderVisibility(false);
	// 			this._data.toastrShow("Payment Successful" , "info");
	// 		}
	// 	);
	// }

	processSubscriptionPayment(tokenObj){
		var price = parseFloat(tokenObj.price);
		let paymentObj = 
			{
				"licenceId" 	: this.planData.id || this.planData.licenceId,
				"price" 		: price.toFixed(2),
				"currencyCode" 	: this.priceCurrency.currencyCode,
				"stripeEmail" 	: tokenObj.email,
				"stripeToken" 	: tokenObj.id
			};
		this._data.changeLoaderVisibility(true);
		if(this.planData.isNewLicence){
			this._payment.processSubscriptionPaymentV2Update(paymentObj)
			.subscribe(
				(res)=>{
					this.showCheckoutWizard = false ;
					this.isTrxnSuccessful = true ;
					this._data.changeLoaderVisibility(false);
					this._data.toastrShow("Payment Successful" , "info");
				}
			);
		}else{
			this._payment.processSubscriptionPaymentV2Add(paymentObj)
			.subscribe(
				(res)=>{
					this.showCheckoutWizard = false ;
					this.isTrxnSuccessful = true ;
					this._data.changeLoaderVisibility(false);
					this._data.toastrShow("Payment Successful" , "info");
				}
			);
		}
	}

	processTrialSubscriptionPayment(tokenObj,nextPlan){
		console.log(tokenObj,nextPlan)
		let paymentObj = 
			{
				"trailPlanId" 	: this.planData.id || this.planData.licenceId,
				"nextPlanId" 	: nextPlan.licenceId,
				"price" 		: 0,
				"currencyCode" 	: this.priceCurrency.currencyCode,
				"stripeEmail" 	: tokenObj.email,
				"stripeToken" 	: tokenObj.id
			};
		this._data.changeLoaderVisibility(true);
		this._payment.processTrialSubscriptionPayment(paymentObj)
		.subscribe(
			(res)=>{
				this.showCheckoutWizard = false ;
				this.isTrxnSuccessful = true ;
				this.trialPlan = nextPlan.licenceName;
				this._data.changeLoaderVisibility(false);
				this._data.toastrShow("Payment Successful" , "info");
			}
		);
	}

	finishProcess(){
		let obj = { "isPaymentSuccessful" :  true }
		this.paymentComplete.emit(obj);
	}

}
